<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} vùng dịch
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tỉnh">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.province_id"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listProvince"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3">
                    <el-form-item label="Cấp độ dịch">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.level"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listLevels"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                  <b-col md="3">
                    <el-form-item label="Trạng thái dịch">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.epidemic_status"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listEpidemicStatus"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số ca nhiễm bệnh">
                      <el-input v-model="mData.tableRules.dataSearch.value.number_of_infections" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số ca phục hồi">
                      <el-input v-model="mData.tableRules.dataSearch.value.number_of_recovery" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số ca tử vong">
                      <el-input v-model="mData.tableRules.dataSearch.value.number_of_mortality" clearable></el-input>
                    </el-form-item>
                  </b-col>       
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-2">             
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                plain
                v-if="aRole('VNATAdmin')"
              >{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <!-- <el-table-column prop="type" label="Loại" width="150">
            <template slot-scope="scope">
              {{scope.row.ten_vung_dich}}
            </template>
          </el-table-column>-->
          <el-table-column prop="province_id" label="Tỉnh" min-width="150">
            <template slot-scope="scope">{{scope.row.ten_tinh}}</template>
          </el-table-column>
          <!-- <el-table-column prop="level" label="Cấp độ dịch" min-width="250">
            <template slot-scope="scope">{{scope.row.ten_level}}</template>
          </el-table-column> -->
          <el-table-column prop="level" label="Trạng thái dịch" min-width="250">
            <template slot-scope="scope">{{scope.row.ten_epidemic_status}}</template>
          </el-table-column>
          <el-table-column prop="number_of_infections" label="Tổng số nhiễm bệnh" align="right" min-width="150"></el-table-column>
          <el-table-column prop="number_of_recovery" label="Tổng số phục hồi" align="right" min-width="150"></el-table-column>
          <el-table-column prop="number_of_mortality" label="Tổng số tử vong" align="right" min-width="150"></el-table-column>
          <!-- <el-table-column
            prop="district_id"
            
            label="Huyện"
            min-width="200"
          ><template slot-scope="scope">
              {{scope.row.ten_huyen}}
            </template></el-table-column>
           <el-table-column
            prop="commune_id"
            
            label="Xã"
            min-width="200"
          ><template slot-scope="scope">
              {{scope.row.ten_xa}}
            </template></el-table-column>
           <el-table-column
            prop="address"
            
            label="Địa điểm"
            min-width="200"
          ></el-table-column>
           <el-table-column
            prop="lng"
            
            label="Kinh độ"
            min-width="150"
          ></el-table-column>
           <el-table-column
            prop="lat"
            
            label="Vĩ độ"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="created_time"
            label="Thời gian tạo"
            :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>-->

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-if="aRole('VNATAdmin')"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-if="aRole('VNATAdmin')"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import VungDichModel from "./VungDichModel";
import VungDichApi from "../../../moduleApi/VungDichApi";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import AccountApi from "../../../moduleApi/AccountApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "VungDich", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(VungDichModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listTypes: VungDichModel.types,
          listLevels: VungDichModel.levels,
          listEpidemicStatus: VungDichModel.epidemic_status,
          listProvince: [],
          listDistrict: [],
          listCommune: [],
        },
        dataForm: MethodService.copyObject(VungDichModel.dataForm),
        validForm: VungDichModel.validForm,
      },
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        });
      }

      let res = await VungDichApi.list(dataFilter);
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(VungDichModel.dataForm),
        res.result
      );

      // let provinceIds = MethodService.findListItemDifferent(
      //   resData,
      //   "province_id"
      // );
      let districtIds = MethodService.findListItemDifferent(
        resData,
        "district_id"
      );
      let communeIds = MethodService.findListItemDifferent(
        resData,
        "commune_id"
      );

      // let resProvinceApi = await ProvinceApi.list({
      //   limit: provinceIds.length,
      //   filters: "id:in:" + provinceIds.join(","),
      // });
      let resDistrictApi = await DistrictApi.list({
        limit: districtIds.length,
        filters: "id:in:" + districtIds.join(","),
      });
      let resCommuneApi = await CommuneApi.list({
        limit: communeIds.length,
        filters: "id:in:" + communeIds.join(","),
      });

      // this.mData.dataDefault.listProvince = resProvinceApi.result;
      this.mData.dataDefault.listDistrict = resDistrictApi.result;
      this.mData.dataDefault.listCommune = resCommuneApi.result;

      $.each(resData, (index, item) => {
        let loaiVungDich = this.mData.dataDefault.listTypes.find((element) => {
          return element.code == item.type;
        });
        item.ten_vung_dich = loaiVungDich ? loaiVungDich.text : "";

        let levelVungDich = this.mData.dataDefault.listLevels.find(
          (element) => {
            return element.code == item.level;
          }
        );
        item.ten_level = levelVungDich ? levelVungDich.text : "";

        item.ten_epidemic_status = (this.mData.dataDefault.listEpidemicStatus.find(status => status.code == item.epidemic_status) || {text: "An toàn"}).text;

        let tenTinh = this.mData.dataDefault.listProvince.find((element) => {
          return element.id == item.province_id;
        });
        item.ten_tinh = tenTinh ? tenTinh.name : "";

        let tenHuyen = this.mData.dataDefault.listDistrict.find((element) => {
          return element.id == item.district_id;
        });
        item.ten_huyen = tenHuyen ? tenHuyen.name : "";

        let tenXa = this.mData.dataDefault.listCommune.find((element) => {
          return element.id == item.commune_id;
        });
        item.ten_xa = tenXa ? tenXa.name : "";
      });

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await VungDichApi.delete(id);
      this.fn_initTable();
    },

    //event table
    // async fn_findNguoiCheckin(query) {
    //   if (!query) {
    //     return;
    //   }
    //   let resProfile = await KhachDuLichApi.list({
    //     limit: 1000,
    //     filters: `ho_ten.ho_ten:regex_i:${query}`
    //   });
    //   if (resProfile.result && resProfile.result.length > 0) {
    //     this.mData.dataDefault.listFindNguoiCheckin = resProfile.result;
    //   }
    // },
    // async fn_findDDAT(query) {
    //   if (!query) {
    //     return;
    //   }
    //   let resDDAT = await DiemDenAnToanApi.list({
    //     limit: 1000,
    //     filters: `thong_tin_chung.ten:regex_i:${query}`
    //   });
    //   if (resDDAT.result && resDDAT.result.length > 0) {
    //     this.mData.dataDefault.listFindDDAT = resDDAT.result;
    //   }
    // },

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.number_of_infections){
        this.mData.tableRules.dataSearch.value.number_of_infections = this.mData.tableRules.dataSearch.value.number_of_infections.trim();
      }
      if(this.mData.tableRules.dataSearch.value.number_of_recovery){
        this.mData.tableRules.dataSearch.value.number_of_recovery = this.mData.tableRules.dataSearch.value.number_of_recovery.trim();
      }
      if(this.mData.tableRules.dataSearch.value.number_of_mortality){
        this.mData.tableRules.dataSearch.value.number_of_mortality = this.mData.tableRules.dataSearch.value.number_of_mortality.trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";

          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach((item) => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {
      // this.mData.dataDefault.currentUser = MethodService.getCurrentUser();
      let resProvince = await ProvinceApi.list({
        limit: 1000
      });
      if (resProvince.result) {
        this.mData.dataDefault.listProvince = resProvince.result;
      }  
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      // if (this.mData.tableRules.dataSearch.value.nguoi_check_in_id) {
      //   let resProfile = await KhachDuLichApi.findById(
      //     this.mData.tableRules.dataSearch.value.nguoi_check_in_id
      //   );
      //   if (resProfile.result) {
      //     this.mData.dataDefault.listFindNguoiCheckin.push(resProfile.result);
      //   }
      // }
      // if (this.mData.tableRules.dataSearch.value.diem_den_an_toan_id) {
      //   let resDDAT = await ProfileApi.findById(
      //     this.mData.tableRules.dataSearch.value.diem_den_an_toan_id
      //   );
      //   if (resDDAT.result) {
      //     this.mData.dataDefault.listFindNguoiCheckin.push(resDDAT.result);
      //   }
      // }
    },
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
